import Icon from '@mui/icons-material/AccountBox'

const config = { name: 'accounts', recordRepresentation: 'name', icon: Icon }

export const ACCOUNT_BASE_PATH = '/' + config.name

export default config
